import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  TextField
} from "@mui/material";

import axios from "axios";

const FilterControlsPDPVCDP = ({ onReportData,setLoading,loading }) => {
  
  const [offOn, setOffOn] = useState("All");
  const [extDate, setExtDate] = useState();

  const [extDateOptions, setExtDateOptions] = useState([]);



  const handleOffOnChange = (event) => {
    setOffOn(event.target.value);
  };
  const handleExtDateChange = (event) => {
    setExtDate(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
    try {
      setLoading(true);
      
      const extDataDD = await axios.get(
        process.env.REACT_APP_API_BASE_URL+"/pdp/getReportExtractionDateDD",
        {
          params: {
          },
        }
      );
      console.log('On load report Ext Date : ',extDataDD);
      const dates = extDataDD.data.map(item => item.report_extraction_date); 
      const maxDate = dates.reduce((a, b) => (a > b ? a : b)); 
    
      setExtDateOptions(extDataDD.data);
    
        setExtDate(maxDate);

    }
    catch (error) {
      console.error("Error fetching report Single Select::", error);
      // You might want to add error handling UI here
    } finally {
      setLoading(false);
    }
  }
  fetchData();
      

  },[]); 
  
  useEffect(() => { 
  
    if (extDate) { 
       setLoading(true);
      handleViewReport(); 
      setTimeout(() => {
           setLoading(false);
      }, 500);
    
    }
   }, [extDate,offOn]);

  console.log('Fetched Extraction Date',extDateOptions);
  
  

  

  const handleViewReport = async () => {
    try {
      setLoading(true);
           console.log(extDate);

      // Consolidated endpoints: one call per EIPO category returns both revenue grade
      // buckets (A+ and P*). fromDate is omitted, so the API compares against extDate.
      const payload = { offOn, extDate };

      const [eiPDPData, dpoPDPData, eiVCDPData, dpoVCDPData] = await Promise.all([
        axios.post(process.env.REACT_APP_API_BASE_URL+"/pdp/getPDPData", { ...payload, eipo: "EI" }),
        axios.post(process.env.REACT_APP_API_BASE_URL+"/pdp/getPDPData", { ...payload, eipo: "PO" }),
        axios.post(process.env.REACT_APP_API_BASE_URL+"/vcdp/getVCDPData", { ...payload, eipo: "EI" }),
        axios.post(process.env.REACT_APP_API_BASE_URL+"/vcdp/getVCDPData", { ...payload, eipo: "PO" }),
      ]);

      // Order must stay EI A+, EI P*, PO A+, PO P* to match the table names in PDPVCDP.js
      const pdpResponseData = [
        eiPDPData.data?.aPlus || [],
        eiPDPData.data?.pStar || [],
        dpoPDPData.data?.aPlus || [],
        dpoPDPData.data?.pStar || [],
      ];

      const vcdpResponseData = [
        eiVCDPData.data?.aPlus || [],
        eiVCDPData.data?.pStar || [],
        dpoVCDPData.data?.aPlus || [],
        dpoVCDPData.data?.pStar || [],
      ];

      const pdpResponse= {pdpResponseData : pdpResponseData};
      const vcdpResponse = {vcdpResponseData : vcdpResponseData};
      const pdpVcdpResponse = Object.assign({},pdpResponse,vcdpResponse);
      
        if (onReportData) {
            console.log("PDPVCDP",pdpVcdpResponse);
          onReportData(pdpVcdpResponse, {  offOn }); // Pass filter values here
        }
      
      
    } catch (error) {
      console.error("Error fetching report::", error);
      // You might want to add error handling UI here
    } finally {
      setLoading(false);
    }
  };

  const isButtonDisabled =loading;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        mb: 3,
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="kilo"
    >
      
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="off-on-label">Off/On</InputLabel>
        <Select
          labelId="off-on-label"
          id="off-on-select"
          value={offOn}
          label="Off/On"
          onChange={handleOffOnChange}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="onsite">onsite</MenuItem>
          <MenuItem value="offshore">offshore</MenuItem>
        </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="report-extraction-label">Extraction Date</InputLabel>
        <Select
          labelId="report-extraction-label"
          id="report-extraction-select"
          value={extDate ||""}
          defaultValue={extDate||""}
          label="Extraction Date"
          onChange={handleExtDateChange}
        >
        {extDateOptions.map((option, index) => (
        <MenuItem key={index} value={option.report_extraction_date}>
          {option.report_extraction_date}
        </MenuItem>))}
        </Select>
      </FormControl>

      
   
      {/* <Button
        variant="contained"
        color="primary"
        onClick={handleViewReport}
        disabled={isButtonDisabled}
      >
        {loading ? "Loading..." : "View Report"}
      </Button> */}
    </Box>
  );
};

export default FilterControlsPDPVCDP;
